import avatar10 from "assets/images/users/32/avatar-10.jpg";
import avatar9 from "assets/images/users/32/avatar-9.jpg";
import avatar8 from "assets/images/users/32/avatar-8.jpg";
import avatar7 from "assets/images/users/32/avatar-7.jpg";
import avatar6 from "assets/images/users/32/avatar-6.jpg";
import avatar5 from "assets/images/users/32/avatar-5.jpg";
import avatar4 from "assets/images/users/32/avatar-4.jpg";
import avatar3 from "assets/images/users/32/avatar-3.jpg";
import avatar1 from "assets/images/users/32/avatar-1.jpg";

const agentlistdata = [
    {
        id: 1,
        joiningdate: "19 Nov, 2022",
        img: { priview: avatar1, formattedSize: "4.17 KB", path: "img-1.png", size: '1000' },
        imgalt: "avatar-1.jpg",
        name: "Dianna Bogan",
        property: "149",
        location: "Brasília, Brazil",
        email: "dianna@steex.com",
        course: "Full Stack Developer",
        contact: "(86) 9985-9220",
        status: "Active",
        new: true
    }, {
        id: 2,
        joiningdate: "25 Nov, 2022",
        img: { priview: avatar10, formattedSize: "4.10 KB", path: "img-10.png", size: '1010' },
        imgalt: "avatar-10.jpg",
        name: "Josefa Weissnat",
        property: "164",
        location: "California, USA",
        email: "josefaweissnat@steex.com",
        course: "Web Developer",
        contact: "(53) 3035-3100",
        status: "Unactive",
        new: false
    }, {
        id: 3,
        joiningdate: "08 Dec, 2022",
        img: { priview: avatar9, formattedSize: "4.89 KB", path: "img-9.png", size: '3900' },
        imgalt: "avatar-9.jpg",
        name: "Ophelia Steuber",
        property: "279",
        location: "Sobrado, Spain",
        email: "opheliasteuber@steex.com",
        course: "React Developer",
        contact: "(21) 2345-6789",
        status: "Active",
        new: false
    }, {
        id: 4,
        joiningdate: "21 Dec, 2022",
        img: { priview: avatar8, formattedSize: "4.88 KB", path: "img-8.png", size: '3800' },
        imgalt: "avatar-8.jpg",
        name: "Federico Hand",
        property: "487",
        location: "San Luis Potosi, Mexico",
        email: "federico@steex.com",
        contact: "(11) 3666-9716",
        course: "Shopify Developer",
        status: "Active",
        new: false
    }, {
        id: 5,
        joiningdate: "27 Jan, 2023",
        img: { priview: avatar7, formattedSize: "4.77 KB", path: "img-7.png", size: '3700' },
        imgalt: "avatar-7.jpg",
        name: "Uriel King",
        property: "369",
        location: "Ibiza, Spain",
        email: "urielking@steex.com",
        contact: "(92) 3639-8685",
        course: "Shopify Developer",
        status: "Unactive",
        new: true
    }, {
        id: 6,
        joiningdate: "18 Feb, 2023",
        img: { priview: avatar6, formattedSize: "4.67 KB", path: "img-6.png", size: '3060' },
        imgalt: "avatar-6.jpg",
        name: "Buck Roberts",
        property: "495",
        location: "Guarulhos, Brazil",
        email: "buckroberts@steex.com",
        course: "Shopify Developer",
        contact: "(11) 3885-1022",
        status: "Active",
        new: false
    }, {
        id: 7,
        joiningdate: "24 Feb, 2023",
        img: { priview: avatar5, formattedSize: "4.85 KB", path: "img-5.png", size: '3050' },
        imgalt: "avatar-5.jpg",
        name: "Xander Wyman",
        property: "85",
        location: "Logrono, Spain",
        email: "xander@steex.com",
        course: "Angular Developer",
        contact: "(48) 3877-9000",
        status: "Unactive",
        new: true
    }, {
        id: 8,
        joiningdate: "29 Feb, 2023",
        img: { priview: avatar4, formattedSize: "4.84 KB", path: "img-4.png", size: '3400' },
        imgalt: "avatar-4.jpg",
        name: "Donnell Schultz",
        property: "326",
        location: "Natal, Brazil",
        email: "donnell@steex.com",
        course: "Project Manager",
        contact: "(51) 3233-7909",
        status: "Active",
        new: false
    }, {
        id: 9,
        joiningdate: "11 Mar, 2023",
        img: { priview: avatar3, formattedSize: "4.83 KB", path: "img-3.png", size: '3300' },
        imgalt: "avatar-3.jpg",
        name: "Jacinthe Will",
        property: "741",
        location: "Brasília, Brazil",
        email: "dianna@steex.com",
        contact: "(33) 3521-6761",
        course: "Graphic Designer",
        status: "Active",
        new: true
    }, {
        id: 10,
        joiningdate: "15 Mar, 2023",
        img: { priview: avatar10, formattedSize: "4.00 KB", path: "img-10.png", size: '3100' },
        imgalt: "avatar-10.jpg",
        name: "Josefa Weissnat",
        property: "159",
        location: "California, USA",
        email: "josefaweissnat@steex.com",
        course: "CEO & Founder",
        contact: "(53) 3035-3100",
        status: "Unactive",
        new: false
    }, {
        id: 11,
        joiningdate: "17 Mar, 2023",
        img: { priview: avatar6, formattedSize: "4.67 KB", path: "img-6.png", size: '3060' },
        imgalt: "avatar-6.jpg",
        name: "Buck Roberts",
        property: "149",
        location: "Guarulhos, Brazil",
        email: "buckroberts@steex.com",
        course: "Flask Development",
        contact: "(11) 3885-1022",
        status: "Active",
        new: false
    },{
        id: 12,
        joiningdate: "25 Feb, 2023",
        img: { priview: avatar5, formattedSize: "4.85 KB", path: "img-5.png", size: '3050' },
        imgalt: "avatar-5.jpg",
        name: "Isabel Hardwicke",
        property: "85",
        location: "Kankaanpääntie 64 94450 KEMINMAA",
        email: "isabelhardwicke@steex.com",
        course: "Angular Developer",
        contact: "046 535 5916",
        status: "Unactive",
        new: true
    },
];

export { agentlistdata };
